<template>
  <div>
    <el-container class="box">
      <el-backtop :bottom="10"></el-backtop>
      <el-header>
        <header-ht @userChild="content" :toUpdate="headerUpdate"></header-ht>
      </el-header>

      <el-main style="margin-bottom: 60px">
        <div class="w">
          <el-row>
            <el-col :span="7">
              <div class="user_box">
                <div class="headPor">
                  <img v-bind:src="imgUrl" alt />
                  <p
                    v-if="
                      this.RenZhen == '企业用户' ||
                        this.RenZhen == '数据采集合作伙伴(有人机)' ||
                        this.RenZhen == '数据采集合作伙伴(无人机)' ||
                        this.RenZhen == '数据采集合作伙伴' ||
                        this.RenZhen == '数据处理合作伙伴' ||
                        this.RenZhen == '一站式合作伙伴'
                    "
                  >
                    企业头像：
                  </p>
                  <p v-if="this.RenZhen == '个人账号'">个人头像：</p>
                  <div class="file">
                    <a href="javascript:;">
                      上传（*图片在2M以内）
                      <input
                        name="file"
                        type="file"
                        accept="image/png, image/gif, image/jpeg"
                        @change="heardupdate"
                      />
                    </a>
                  </div>
                </div>
                <div class="xingxi">
                  <div class="tiao">
                    <p>企业名称：{{ userData.companyName }}</p>
                    <el-button
                      v-if="this.bianji"
                      type="text"
                      @click="openCompan"
                    >
                      <i>编辑</i>
                    </el-button>
                  </div>
                  <div class="tiao">
                    <p>
                      <span style="letter-spacing:8px">姓 名</span>：{{
                        details.hasOwnProperty("name") ? details.name : ""
                      }}
                    </p>
                    <el-button type="text" @click="openname">
                      <i>编辑</i>
                    </el-button>
                  </div>
                  <div class="tiao">
                    <p>
                      <span style="letter-spacing:8px">职 位</span>：{{
                        details.position
                      }}
                    </p>
                    <el-button type="text" @click="openposition">
                      <i>编辑</i>
                    </el-button>
                  </div>
                  <div class="tiao">
                    <p>身份信息：{{ RenZhen }}</p>
                    <el-button
                      type="text"
                      @click="rengZhen()"
                      v-if="this.RenZhen == '企业用户（审核中）'"
                    >
                      <i>查看认证</i>
                    </el-button>
                    <el-button
                      type="text"
                      @click="rengZhen()"
                      v-if="this.RenZhen == '企业用户（未通过）'"
                    >
                      <i>重新认证</i>
                    </el-button>
                    <el-button
                      type="text"
                      @click="rengZhen()"
                      v-if="this.RenZhen == '企业用户'"
                    >
                      <i>修改信息</i>
                    </el-button>
                  </div>
                  <div class="tiao">
                    <p>
                      <span style="letter-spacing:8px">账 号</span>：{{
                        userData.username
                      }}
                    </p>
                    <el-button type="text" @click="openUser">
                      <i>编辑</i>
                    </el-button>
                  </div>
                  <div class="tiao">
                    <p>
                      <span style="letter-spacing:8px">密 码</span>：********
                    </p>
                    <el-button type="text" @click="openPass">
                      <i>编辑</i>
                    </el-button>
                  </div>
                  <div class="tiao">
                    <p>身份证号：****************</p>
                    <el-button type="text" @click="openlicense">
                      <i>编辑</i>
                    </el-button>
                  </div>
                </div>
              </div>
              <div>
                <!-- <activity></activity> -->
              </div>
              <!-- <div class="user_box2"></div> -->
            </el-col>
            <el-col :span="15">
              <router-view />
            </el-col>
          </el-row>
        </div>
      </el-main>
      <el-footer style="padding:0;height:0;">
        <footer-ht></footer-ht>
      </el-footer>
    </el-container>

    <!-- 密码对话框 -->
    <el-dialog
      width="440px"
      title="密码修改"
      :visible.sync="pasDialogFormVisible"
    >
      <el-form
        autocomplete="off"
        label-width="50px"
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
      >
        <el-form-item prop="oldPass">
          <el-input
            style="width: 320px"
            placeholder="请输入旧密码"
            show-password
            v-model="ruleForm.oldPass"
          ></el-input>
        </el-form-item>
        <el-form-item prop="pass" label-width="50px">
          <el-input
            v-model="ruleForm.pass"
            placeholder="请输入新密码"
            style="width: 320px"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item prop="checkPass" label-width="50px">
          <el-input
            v-model="ruleForm.checkPass.password"
            placeholder="请再次输入密码"
            style="width: 320px"
            show-password
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="pasDialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="editPass()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 手机号对话框 -->
    <el-dialog
      width="440px"
      title="手机号修改"
      :visible.sync="useDialogFormVisible"
    >
      <el-form
        ref="editForm"
        :rules="editRules"
        :model="editForm"
        autocomplete="off"
        label-width="50px"
      >
        <el-form-item prop="username">
          <el-input
            style="width: 320px"
            v-model="editForm.username"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>

        <el-form-item prop="verification" label-width="50px">
          <el-input
            v-model="editForm.code.code"
            placeholder="请输入手机验证码"
            style="width: 200px"
          ></el-input>
          <el-button
            @click="send()"
            style=" width: 110px;height: 40px;margin-left: 10px;background-color: #fff;border: 1px solid #0086FD;"
            type="success"
            :disabled="(disabled = !show)"
            ref="butStyle"
          >
            <span v-show="show" style="color: #0086FD">申请发送</span>
            <span v-show="!show" class="count" style="color: #C5C6D1"
              >{{ count }} s</span
            >
          </el-button>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="useDialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="editUser()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 职位对话框 -->
    <el-dialog width="440px" title="职位修改" :visible.sync="positiontanchuang">
      <el-form
        autocomplete="off"
        ref="positionForm"
        :rules="positionRules"
        :model="positionForm"
      >
        <el-form-item label="职位:" prop="position">
          <el-input v-model="positionForm.position"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="positiontanchuang = false">取 消</el-button>
        <el-button type="primary" @click="positionCom()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 身份证号对话框 -->
    <el-dialog
      width="440px"
      title="身份证号修改"
      :visible.sync="licensetanchuang"
    >
      <el-form
        autocomplete="off"
        ref="licenseForm"
        :rules="licenseRules"
        :model="licenseForm"
      >
        <el-form-item label="身份证号:" prop="license">
          <el-input v-model="licenseForm.license"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="licensetanchuang = false">取 消</el-button>
        <el-button type="primary" @click="licenseCom()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 姓名对话框 -->
    <el-dialog width="440px" title="姓名修改" :visible.sync="nametanchuang">
      <el-form
        autocomplete="off"
        ref="nameForm"
        :rules="nameRules"
        :model="nameForm"
      >
        <el-form-item label="姓名:" prop="name">
          <el-input v-model="nameForm.name"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="nametanchuang = false">取 消</el-button>
        <el-button type="primary" @click="nameCom()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 编辑对话框 -->
    <el-dialog
      width="440px"
      title="企业名称修改"
      :visible.sync="comDialogFormVisible"
    >
      <el-form
        autocomplete="off"
        ref="companyName"
        :rules="companyNameRules"
        :model="companyName"
      >
        <el-form-item label="企业名称:" prop="companyName">
          <el-input v-model="companyName.companyName"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="comDialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="editCom()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import headerHt from "../components/header";
import footerHt from "../components/footer";
// import activity from "../components/activity";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    headerHt,
    footerHt
    // activity
  },

  data() {
    // var validateUser = (rule, value, callback) => {
    //   if (value === "") {
    //     callback(new Error("请输入验证码"));
    //   } else if (this.editForm.grapVerification !== this.identifyCode) {
    //     callback(new Error("验证码错误!"));
    //   } else {
    //     callback();
    //   }
    // };
    // var validatePass = (rule, value, callback) => {
    //   if (value === "") {
    //     callback(new Error("请输入旧密码"));
    //   } else if (this.ruleForm.oldPass !== this.userData.password) {
    //     callback(new Error("旧密码错误!"));
    //   } else {
    //     callback();
    //   }
    // };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (this.ruleForm.checkPass.password !== this.ruleForm.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    //这里存放数据
    return {
      headerUpdate: false,
      show: true, // 初始启用按钮
      count: "", // 初始化次数

      rules: {
        // oldPass: [{ validator: validatePass, trigger: "blur" }],
        pass: [
          { required: true, message: "新密码必填", trigger: "blur" },
          { min: 6, max: 20, message: "不小于六位", trigger: "blur" }
        ],
        checkPass: [{ validator: validatePass2, trigger: "blur" }]
      },
      // 修改密码form表单数据对象
      ruleForm: {
        oldPass: "",
        pass: "",
        checkPass: { password: "" }
      },
      pasDialogFormVisible: false,
      //手机号编辑相关数据
      useDialogFormVisible: false,
      editForm: {
        username: "",
        code: { code: "", phone: "" }
      },
      //修改手机号验证规则
      editRules: {
        username: [
          { required: true, message: "手机号必填", trigger: "blur" },
          { min: 11, max: 11, message: "请输入11位手机号码", trigger: "blur" }
        ]
      },
      licensetanchuang: false,

      positiontanchuang: false,

      comDialogFormVisible: false,
      caijixuanze: false,
      nametanchuang: false,
      imgUrl: require("../assets/img/tianjiatouxiang.png"),
      bianji: true,

      yaoqinData: {
        column:
          "t_order.*,t_dispatch.id dispatchId,t_dispatch.status dispatchStatus,t_dispatch.data dispatchData",
        function: "",
        condition: ""
      },
      invitationRules: {
        invitation: [
          { required: true, message: "请输入邀请码", trigger: "blur" },
          { min: 16, max: 16, message: "请输入16位邀请码", trigger: "blur" }
        ]
      },
      invitationForm: {
        invitation: ""
      },
      orders: [],
      billing: [],
      reqParams: {
        function: "t_order,t_user",
        condition: "",
        column:
          "t_order.*,t_user.username,t_user.companyName,t_user.data userData"
      },
      ordersData: {
        function: "t_dispatch,t_order",
        column:
          "t_order.*,t_dispatch.id dispatchId,t_dispatch.status dispatchStatus,t_dispatch.data dispatchData",
        condition: ""
      },
      update: {
        function: "t_order",
        ids: ""
      },
      update1: {
        function: "t_dispatch",
        ids: ""
      },
      RenZhen: "",
      RenZhenZhuangTai: "未认证",
      CaiJiYouRenJi: "未认证",
      CaiJiWuRenJi: "未认证",
      ChuLiZhuangTai: "未认证",
      activeName: "first",
      circleUrl:
        "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      squareUrl:
        "https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png",
      sizeList: ["large", "medium", "small"],
      DialogFormVisible: false,
      details: {},
      userData: {},
      //企业
      companyName: {
        companyName: ""
      },
      companyNameRules: {
        companyName: [
          { required: true, message: "企业名称必填", trigger: "blur" },
          { max: 12, message: "最多12个字符", trigger: "blur" }
        ]
      },
      //姓名
      nameForm: {
        name: ""
      },
      nameRules: {
        name: [{ required: true, message: "姓名必填", trigger: "blur" }]
      },
      //身份证号
      licenseForm: {
        license: ""
      },
      licenseRules: {
        license: [{ required: true, message: "身份证号必填", trigger: "blur" }]
      },
      //职位
      positionForm: {
        position: ""
      },
      positionRules: {
        position: [{ required: true, message: "职位必填", trigger: "blur" }]
      },
      auth1: {}
    };
  },
  computed: {
    reversedMessage: function() {
      return this.username.replace(/(^\d{3}|\d{4}\B)/g, "$1-");
    }
  },
  //方法集合
  methods: {
    rengZhen() {
      if (this.RenZhen == "企业用户（审核中）") {
        this.$router.push({
          path: "/certification",
          query: { dataId: "1" }
        });
      } else {
        this.$router.push({
          path: "/enterCertifi"
        });
      }
    },
    //密码啊修改
    editPass() {
      this.$refs.ruleForm.validate(async valid => {
        if (valid) {
          let udate = {
            function: "t_user",
            id: "",
            jsonData: {}
          };
          udate.id = this.userData.id;
          udate.jsonData = JSON.stringify(this.ruleForm.checkPass);
          var { data: dt } = await this.$http.post("general/update", udate);

          if (dt.status !== 200) {
            return this.$message.error(dt.msg);
          }
          this.$message({
            message: "修改密码成功",
            type: "success"
          });
          this.pasDialogFormVisible = false;
        }
      });
    },
    //发送验证码倒计时
    async send() {
      if (this.editForm.username.username == "") {
        return this.$message.error("请输入手机号");
      }

      this.show = true;
      this.$refs.butStyle.$el.style.border = "1px solid #C5C6D1";

      const TIME_COUNT = 60; //更改倒计时时间
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer); // 清除定时器
            this.timer = null;
            this.$refs.butStyle.$el.style.border = "1px solid #0086FD";
          }
        }, 1000);
      }
      let phone = {
        phone: ""
      };
      phone.phone = this.editForm.username;
      var { data: dt } = await this.$http.post("general/sendCode", phone);

      if (dt.status !== 200) {
        return this.$message.error(dt.msg);
      }
    },
    //账号修改
    editUser() {
      this.$refs.editForm.validate(async valid => {
        if (valid) {
          this.editForm.code.phone = this.editForm.username;
          var { data: dt } = await this.$http.post(
            "general/checkCode",
            this.editForm.code
          );

          if (dt.status !== 200) {
            return this.$message.error(dt.msg);
          }

          if (dt.data === 1) {
            return this.$message.error("验证码过期");
          } else if (dt.data === 2) {
            return this.$message.error("验证码错误");
          }
          let username = {
            username: ""
          };
          let udate = {
            function: "t_user",
            id: "",
            jsonData: {}
          };
          udate.id = this.userData.id;
          username.username = this.editForm.username;
          udate.jsonData = JSON.stringify(username);
          this.$http.post("general/update", udate).then(response => {
            if (response.data.status !== 200) {
              return this.$message.error(response.data.msg);
            }
            this.$message({
              message: "修改手机号成功",
              type: "success"
            });
          });
          this.useDialogFormVisible = false;
          // this.content();
          this.headerUpdate = true;
        }
      });
    },
    //职位
    positionCom() {
      this.$refs.positionForm.validate(async valid => {
        if (valid) {
          let udate = {
            function: "t_user",
            id: "",
            jsonData: { data: {} }
          };
          udate.id = this.userData.id;
          this.details.position = this.positionForm.position;
          udate.jsonData.data = JSON.stringify(this.details);

          udate.jsonData = JSON.stringify(udate.jsonData);
          var { data: dt } = await this.$http.post("general/update", udate);

          if (dt.status !== 200) {
            return this.$message.error(dt.msg);
          }

          this.$message({
            message: "修改成功",
            type: "success"
          });

          this.positiontanchuang = false;
          this.headerUpdate = true;
        }
      });
    },
    //身份证号
    licenseCom() {
      this.$refs.licenseForm.validate(async valid => {
        if (valid) {
          let udate = {
            function: "t_user",
            id: "",
            jsonData: { data: {} }
          };
          udate.id = this.userData.id;
          this.details.license = this.licenseForm.license;
          udate.jsonData.data = JSON.stringify(this.details);

          udate.jsonData = JSON.stringify(udate.jsonData);
          var { data: dt } = await this.$http.post("general/update", udate);

          if (dt.status !== 200) {
            return this.$message.error(dt.msg);
          }

          this.$message({
            message: "修改成功",
            type: "success"
          });

          this.licensetanchuang = false;
          this.headerUpdate = true;
        }
      });
    },
    //姓名编辑
    nameCom() {
      this.$refs.nameForm.validate(async valid => {
        if (valid) {
          let udate = {
            function: "t_user",
            id: "",
            jsonData: { data: {} }
          };
          udate.id = this.userData.id;
          this.details.name = this.nameForm.name;
          udate.jsonData.data = JSON.stringify(this.details);

          udate.jsonData = JSON.stringify(udate.jsonData);
          var { data: dt } = await this.$http.post("general/update", udate);

          if (dt.status !== 200) {
            return this.$message.error(dt.msg);
          }

          this.$message({
            message: "修改成功",
            type: "success"
          });

          this.nametanchuang = false;
          this.headerUpdate = true;
        }
      });
    },
    //提交修改企业名称
    editCom() {
      if (this.userData.companyName == this.companyName.companyName) {
        return this.$message.error("未修改企业名称");
      }
      this.$refs.companyName.validate(async valid => {
        if (valid) {
          var { data: dt } = await this.$http.post(
            "user/updateCompanyName",
            this.companyName
          );

          if (dt.status !== 200) {
            return this.$message.error(dt.msg);
          }
          if (dt.data == 1) {
            return this.$message.error("企业名称已存在");
          }
          this.$message({
            message: "修改成功",
            type: "success"
          });

          this.comDialogFormVisible = false;
          this.headerUpdate = true;
        }
      });
    },
    openposition() {
      this.positiontanchuang = true;
    },
    openlicense() {
      this.licensetanchuang = true;
    },
    openname() {
      this.nametanchuang = true;
    },
    //企业名称修改
    openCompan() {
      this.comDialogFormVisible = true;
    },
    //手机号修改
    openUser() {
      this.useDialogFormVisible = true;
    },
    //密码修改
    openPass() {
      this.pasDialogFormVisible = true;
    },
    //上传头像
    heardupdate(e) {
      // 上传照片
      // var self = this;
      let file = e.target.files[0];
      /* eslint-disable no-undef */
      let param = new FormData(); // 创建form对象
      param.append("file", file); // 通过append向form对象添加数据
      // param.append("chunk", "0"); // 添加form表单中其他数据
      // console.log(param.get("file")); // FormData私有类对象，访问不到，可以通过get判断值是否传进去
      let config = {
        headers: { "Content-Type": "multipart/form-data" }
      };
      // 添加请求头
      this.$http.post("general/upload", param, config).then(response => {
        if (response.data.status !== 200) {
          return this.$message.error(response.data.msg);
        }

        this.imgUrl =
          this.$http.defaults.baseURL +
          "file" +
          "/" +
          response.data.data.result;
        this.details.userhead = response.data.data.result;

        let udate = {
          function: "t_user",
          id: "",
          jsonData: { data: {} }
        };
        udate.id = this.userData.id;
        udate.jsonData.data = JSON.stringify(this.details);

        udate.jsonData = JSON.stringify(udate.jsonData);
        this.$http.post("general/update", udate).then(response => {
          if (response.data.status !== 200) {
            return this.$message.error(response.data.msg);
          }
          this.headerUpdate = true;
        });
      });
    },

    elastic() {
      this.DialogFormVisible = true;
    },

    //个人信息
    content(data) {
      this.userData = data;

      this.details = this.userData.data;

      if (this.details.hasOwnProperty("userhead")) {
        this.imgUrl =
          this.$http.defaults.baseURL + "file" + "/" + this.details.userhead;
      }

      if (this.details.userhead) {
        this.userhead =
          this.$http.defaults.baseURL + "file" + "/" + this.details.userhead;
      }
      if (this.userData.type == 0) {
        this.RenZhen = "个人账号";
      }
      if (this.userData.type == 1) {
        this.RenZhen = "企业用户";
        this.bianji = false;
      }
      if (this.userData.type == 6) {
        this.RenZhen = "数据采集合作伙伴";
        this.bianji = false;
      }
      if (this.userData.type == 5) {
        this.RenZhen = "一站式合作伙伴";
        this.bianji = false;
      }
      if (this.userData.type == 2) {
        this.RenZhen = "数据采集合作伙伴(无人机)";
        this.bianji = false;
      }
      if (this.userData.type == 3) {
        this.RenZhen = "数据处理合作伙伴";
        this.bianji = false;
      }
      if (this.userData.type == 4) {
        this.RenZhen = "数据采集合作伙伴(有人机)";
        this.bianji = false;
      }
      if (this.userData.type == 7) {
        this.RenZhen = "一站式合作伙伴";
        this.bianji = false;
      }
      if (this.userData.type == 9) {
        this.RenZhen = "一站式合作伙伴";
        this.bianji = false;
      }
      this.userData.auth.forEach(e => {
        if (e.type == 1) {
          if (e.status == 1) {
            this.qiyezhuangtaizhong = true;
            this.RenZhen = "企业用户（审核中）";
            this.RenZhenZhuangTai = "认证中";
          }
          if (e.status == 2) {
            this.qiyezhuangtaizhong = true;
            this.RenZhen = "企业用户（未通过）";
            this.RenZhenZhuangTai = "认证驳回";
          }
          if (e.status == 3) {
            this.RenZhenZhuangTai = "认证完成";
          }
        }
        if (e.type == 2) {
          if (e.status == 1) {
            this.CaiJiWuRenJi = "认证中";
          }
          if (e.status == 2) {
            this.CaiJiWuRenJi = "认证驳回";
          }
          if (e.status == 3) {
            this.CaiJiWuRenJi = "认证完成";
          }
        }
        if (e.type == 4) {
          if (e.status == 1) {
            this.CaiJiYouRenJi = "认证中";
          }
          if (e.status == 2) {
            this.CaiJiYouRenJi = "认证驳回";
          }
          if (e.status == 3) {
            this.CaiJiYouRenJi = "认证完成";
          }
        }

        if (e.type == 3) {
          if (e.status == 1) {
            this.ChuLiZhuangTai = "认证中";
          }
          if (e.status == 2) {
            this.ChuLiZhuangTai = "认证驳回";
          }
          if (e.status == 3) {
            this.ChuLiZhuangTai = "认证完成";
          }
        }
      });

      if (this.RenZhen == "数据采集合作伙伴") {
        this.CaiJiWuRenJi = "认证完成";
        this.CaiJiYouRenJi = "认证完成";
      }
    }
  },
  created() {},
  mounted() {
    // this.content();
  }
};
</script>
<style lang="less" scoped>
//@import url(); 引入公共css类
.el-main {
  padding: 0;
  width: 100%;
  min-height: calc(100vh - 160px);
  padding-top: 100px;
}
.box {
  background: #f7f4f8;

  height: auto;
  // margin-top: 60px;
  // padding-top: 120px;
  // padding-bottom: 60px;
}
.el-header {
  padding: 0;
}
.w {
  width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
}
.neirong {
  display: flex;
  // justify-content: flex-end;
  justify-content: space-between;
}
.user_box {
  width: 320px;
  position: relative;
  background: #ffffff;
  // position: fixed;
  border: 1px solid #e5e5e5;
  // top: 0;
  // left: 0;
  // box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.2);
  // height: 520px;
  box-sizing: border-box;
}

.text {
  background: #ffffff;
  // box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.2);
  padding: 40px;
  padding-top: 20px;

  opacity: 1;
}
.title {
  margin-bottom: 30px;
  //   padding: 20px;
  font-size: 16px;
  font-weight: 700;
  display: flex;
  align-items: center;
  .tiao {
    margin-right: 10px;
    width: 4px;
    height: 16px;
    background: #0086fd;
  }
}

i {
  font-style: normal;
}
.headPor {
  padding-top: 80px;
  //   position: absolute;
  //   left: 50%;
  //   top: 80px;

  //   transform: translateX(-50%);
  text-align: center;
  img {
    // position: absolute;
    width: 100px;
    height: 100px;
    border-radius: 10px;
  }
  p {
    margin: 0;
    margin-top: 10px;
  }

  .file {
    position: relative;

    a {
      color: #0086fd;
      font-size: 12px;
    }
    input {
      position: absolute;
      font-size: 12px;
      right: 0;
      top: 0;
      opacity: 0;
      cursor: pointer;
    }
  }
}
.xingxi {
  padding: 30px 40px;
  box-sizing: border-box;
  .tiao {
    margin-bottom: 10px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    p {
      font-size: 14px;
      margin: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-right: auto;
    }
    .el-button {
      padding: 0;
    }
  }
}
</style>
